import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
} from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Add, Delete, DirectionsBike, Map, Save } from "@material-ui/icons"
import { useSnackbar } from "../../../utils/notificacoes"
import { useHistory } from "react-router-dom"
import React, { useEffect, useState } from "react"
import useAppStore from "../../../stores/AppStore"
import { AtribuirFaixasDistanciaActionsTypes } from "../context/atribuirFaixasDistanciaActions"
import { useAtribuirFaixasDistanciaContext } from "../context/useAtribuirFaixasDistanciaContext"
import { FaixaDistancia } from "../models/atribuirFaixasDistanciaModel"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "1100px",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    header: {
        marginBottom: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: theme.spacing(3),
        },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.25rem",
        },
    },
    tipoCalculo: {
        display: "inline-block",
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
        padding: "4px 12px",
        borderRadius: 20,
        fontWeight: 600,
        fontSize: "0.85rem",
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        flexWrap: "wrap",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    mapaButton: {
        borderRadius: 20,
        borderColor: "#4caf50",
        color: "#4caf50",
        fontWeight: 600,
        "&:hover": {
            borderColor: "#388e3c",
            backgroundColor: "rgba(76,175,80,0.08)",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    configCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            marginBottom: theme.spacing(2),
        },
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
        },
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
    },
    tableHead: {
        backgroundColor: "#f8f9fa",
    },
    tableHeadCell: {
        fontWeight: 600,
        color: "#2c3e50",
        whiteSpace: "nowrap",
    },
    tableInput: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 8,
            "& fieldset": {
                borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
                borderColor: "#4caf50",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#4caf50",
            },
        },
    },
    kmCell: {
        color: "#7f8c8d",
        fontStyle: "italic",
        whiteSpace: "nowrap",
    },
    deleteButton: {
        color: "#e53935",
        "&:hover": {
            backgroundColor: "rgba(229,57,53,0.08)",
        },
    },
    addButton: {
        borderRadius: 20,
        borderColor: "#4caf50",
        color: "#4caf50",
        fontWeight: 600,
        "&:hover": {
            borderColor: "#388e3c",
            backgroundColor: "rgba(76,175,80,0.08)",
        },
    },
    saveButton: {
        borderRadius: 25,
        backgroundColor: "#4caf50",
        color: "white",
        padding: theme.spacing(1.5, 4),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(76, 175, 80, 0.3)",
        minWidth: "180px",
        "&:hover": {
            backgroundColor: "#45a049",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "100%",
            padding: theme.spacing(2, 3),
        },
    },
    buttonRow: {
        display: "flex",
        gap: theme.spacing(2),
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        marginTop: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            gap: theme.spacing(1.5),
        },
    },
    // Card layout for mobile
    mobileCard: {
        borderRadius: 15,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        border: "1px solid #e9ecef",
    },
    mobileCardRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    mobileField: {
        flex: 1,
    },
}))

function metersToKm(metros: string): string {
    const n = parseFloat(metros)
    if (isNaN(n)) return "—"
    return (n / 1000).toFixed(3) + " km"
}

export function FaixasDistanciaForm() {
    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { faixas, dispatch, salvar, removerFaixa, erroCarregamento } =
        useAtribuirFaixasDistanciaContext()
    const { enqueueSnackbar } = useSnackbar()
    const configuracoes = useAppStore(s => s.configuracoes)
    const calculoEntrega = configuracoes?.user?.parametros?.calculoEntrega ?? 1
    const mostrarEntregador = calculoEntrega === 2

    const tipoCalculoTexto =
        calculoEntrega === 0 ? "por bairro" : calculoEntrega === 2 ? "por raio" : "por distância"

    useEffect(() => {
        if (erroCarregamento) {
            enqueueSnackbar("Erro ao carregar faixas de distância", { variant: "error" })
        }
    }, [erroCarregamento])

    const handleCampo = (index: number, campo: keyof FaixaDistancia, valor: string | null) => {
        dispatch({
            type: AtribuirFaixasDistanciaActionsTypes.ATUALIZAR_FAIXA,
            payload: { index, campo, valor },
        })
    }

    const handleAdicionar = () => {
        dispatch({ type: AtribuirFaixasDistanciaActionsTypes.ADICIONAR_FAIXA })
    }

    const [confirmacaoAberta, setConfirmacaoAberta] = useState(false)
    const [indexParaRemover, setIndexParaRemover] = useState<number | null>(null)

    const handleRemover = (index: number) => {
        setIndexParaRemover(index)
        setConfirmacaoAberta(true)
    }

    const handleConfirmarRemocao = async () => {
        if (indexParaRemover === null) return
        const faixa = faixas[indexParaRemover]
        setConfirmacaoAberta(false)
        setIndexParaRemover(null)
        try {
            await removerFaixa(indexParaRemover, faixa)
            enqueueSnackbar("Faixa removida com sucesso!", { variant: "success" })
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao remover faixa", {
                variant: "error",
            })
        }
    }

    const handleCancelarRemocao = () => {
        setConfirmacaoAberta(false)
        setIndexParaRemover(null)
    }

    const handleSalvar = async () => {
        const algumaSemDistancia = faixas.some(f => !f.distanciaMaxima.trim())
        if (algumaSemDistancia) {
            enqueueSnackbar("Preencha a distância máxima em todas as faixas", { variant: "error" })
            return
        }
        const algumaSemTaxa = faixas.some(f => !f.taxaEntrega.trim())
        if (algumaSemTaxa) {
            enqueueSnackbar("Preencha a taxa de entrega em todas as faixas", { variant: "error" })
            return
        }

        try {
            await salvar()
            enqueueSnackbar("Faixas de distância salvas com sucesso!", { variant: "success" })
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao salvar faixas", {
                variant: "error",
            })
        }
    }

    const inputField = (
        index: number,
        campo: keyof FaixaDistancia,
        placeholder: string,
        required?: boolean
    ) => (
        <TextField
            className={classes.tableInput}
            variant="outlined"
            size="small"
            fullWidth
            placeholder={placeholder}
            value={(faixas[index][campo] as string) ?? ""}
            onChange={e => handleCampo(index, campo, e.target.value || null)}
            disabled={!!erroCarregamento}
            error={required && !(faixas[index][campo] as string)?.trim()}
        />
    )

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <Box className={classes.header}>
                    <Box>
                        <Typography variant="h4" className={classes.titleText}>
                            Faixas de Distância
                        </Typography>
                        <Typography variant="subtitle1" style={{ color: "#7f8c8d", marginTop: 4 }}>
                            Configure as taxas de entrega por distância
                        </Typography>
                    </Box>
                    <Box className={classes.headerActions}>
                        <span className={classes.tipoCalculo}>Cálculo {tipoCalculoTexto}</span>
                        <Button
                            variant="outlined"
                            className={classes.mapaButton}
                            startIcon={<Map />}
                            onClick={() =>
                                history.push("/servicos/ferramenta/definir-area-de-entrega")
                            }
                        >
                            Definir área no mapa
                        </Button>
                    </Box>
                </Box>

                <Paper className={classes.configCard}>
                    <Box className={classes.cardHeader}>
                        <DirectionsBike className={classes.iconHeader} />
                        <Typography variant="h6" className={classes.cardHeaderTitle}>
                            Faixas cadastradas
                        </Typography>
                    </Box>

                    {!isMobile ? (
                        <TableContainer>
                            <Table size="small">
                                <TableHead className={classes.tableHead}>
                                    <TableRow>
                                        <TableCell className={classes.tableHeadCell}>
                                            Distância máx. (m)
                                        </TableCell>
                                        <TableCell className={classes.tableHeadCell}>
                                            Distância (km)
                                        </TableCell>
                                        <TableCell className={classes.tableHeadCell}>
                                            Taxa de Entrega (R$)
                                        </TableCell>
                                        <TableCell className={classes.tableHeadCell}>
                                            Taxa Noturna (R$)
                                        </TableCell>
                                        <TableCell className={classes.tableHeadCell}>
                                            Mín. p/ Grátis (R$)
                                        </TableCell>
                                        {mostrarEntregador && (
                                            <TableCell className={classes.tableHeadCell}>
                                                Taxa Entregador (R$)
                                            </TableCell>
                                        )}
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {faixas.length === 0 && (
                                        <TableRow>
                                            <TableCell
                                                colSpan={mostrarEntregador ? 7 : 6}
                                                align="center"
                                                style={{ color: "#7f8c8d", padding: 24 }}
                                            >
                                                Nenhuma faixa cadastrada. Clique em "Nova Faixa"
                                                para adicionar.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {faixas.map((faixa, index) => (
                                        <TableRow key={faixa.id ?? `novo-${index}`}>
                                            <TableCell style={{ minWidth: 130 }}>
                                                {inputField(
                                                    index,
                                                    "distanciaMaxima",
                                                    "ex: 5000",
                                                    true
                                                )}
                                            </TableCell>
                                            <TableCell className={classes.kmCell}>
                                                {metersToKm(faixa.distanciaMaxima)}
                                            </TableCell>
                                            <TableCell style={{ minWidth: 130 }}>
                                                {inputField(
                                                    index,
                                                    "taxaEntrega",
                                                    "ex: 5.00",
                                                    true
                                                )}
                                            </TableCell>
                                            <TableCell style={{ minWidth: 130 }}>
                                                {inputField(
                                                    index,
                                                    "taxaEntregaNoturna",
                                                    "ex: 7.00"
                                                )}
                                            </TableCell>
                                            <TableCell style={{ minWidth: 130 }}>
                                                {inputField(
                                                    index,
                                                    "minimoEntregaGratis",
                                                    "ex: 50.00"
                                                )}
                                            </TableCell>
                                            {mostrarEntregador && (
                                                <TableCell style={{ minWidth: 130 }}>
                                                    {inputField(
                                                        index,
                                                        "taxaEntregador",
                                                        "ex: 8.00"
                                                    )}
                                                </TableCell>
                                            )}
                                            <TableCell align="center">
                                                <Tooltip title="Remover faixa">
                                                    <IconButton
                                                        size="small"
                                                        aria-label="Remover faixa"
                                                        className={classes.deleteButton}
                                                        onClick={() => handleRemover(index)}
                                                    >
                                                        <Delete fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Box style={{ padding: 16 }}>
                            {faixas.length === 0 && (
                                <Typography
                                    align="center"
                                    style={{ color: "#7f8c8d", padding: "16px 0" }}
                                >
                                    Nenhuma faixa cadastrada. Clique em "Nova Faixa" para adicionar.
                                </Typography>
                            )}
                            {faixas.map((faixa, index) => (
                                <Box key={faixa.id ?? `novo-${index}`} className={classes.mobileCard}>
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mb={1}
                                    >
                                        <Typography
                                            variant="subtitle2"
                                            style={{ fontWeight: 600, color: "#2c3e50" }}
                                        >
                                            Faixa {index + 1}
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            aria-label="Remover faixa"
                                            className={classes.deleteButton}
                                            onClick={() => handleRemover(index)}
                                        >
                                            <Delete fontSize="small" />
                                        </IconButton>
                                    </Box>
                                    <Box className={classes.mobileCardRow}>
                                        <Box className={classes.mobileField}>
                                            <Typography
                                                variant="caption"
                                                style={{ color: "#7f8c8d", display: "block", marginBottom: 4 }}
                                            >
                                                Distância máx. (m)
                                            </Typography>
                                            {inputField(index, "distanciaMaxima", "ex: 5000", true)}
                                        </Box>
                                        <Box
                                            style={{
                                                minWidth: 80,
                                                textAlign: "center",
                                                paddingTop: 24,
                                            }}
                                        >
                                            <Typography className={classes.kmCell} variant="body2">
                                                {metersToKm(faixa.distanciaMaxima)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box className={classes.mobileCardRow}>
                                        <Box className={classes.mobileField}>
                                            <Typography
                                                variant="caption"
                                                style={{ color: "#7f8c8d", display: "block", marginBottom: 4 }}
                                            >
                                                Taxa de Entrega (R$)
                                            </Typography>
                                            {inputField(index, "taxaEntrega", "ex: 5.00", true)}
                                        </Box>
                                        <Box className={classes.mobileField}>
                                            <Typography
                                                variant="caption"
                                                style={{ color: "#7f8c8d", display: "block", marginBottom: 4 }}
                                            >
                                                Taxa Noturna (R$)
                                            </Typography>
                                            {inputField(index, "taxaEntregaNoturna", "ex: 7.00")}
                                        </Box>
                                    </Box>
                                    <Box className={classes.mobileCardRow}>
                                        <Box className={classes.mobileField}>
                                            <Typography
                                                variant="caption"
                                                style={{ color: "#7f8c8d", display: "block", marginBottom: 4 }}
                                            >
                                                Mín. p/ Grátis (R$)
                                            </Typography>
                                            {inputField(index, "minimoEntregaGratis", "ex: 50.00")}
                                        </Box>
                                        {mostrarEntregador && (
                                            <Box className={classes.mobileField}>
                                                <Typography
                                                    variant="caption"
                                                    style={{ color: "#7f8c8d", display: "block", marginBottom: 4 }}
                                                >
                                                    Taxa Entregador (R$)
                                                </Typography>
                                                {inputField(index, "taxaEntregador", "ex: 8.00")}
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    )}
                </Paper>

                <Box className={classes.buttonRow}>
                    <Button
                        variant="outlined"
                        className={classes.addButton}
                        startIcon={<Add />}
                        onClick={handleAdicionar}
                        disabled={!!erroCarregamento}
                    >
                        Nova Faixa
                    </Button>
                    <Button
                        className={classes.saveButton}
                        startIcon={!isMobile && <Save />}
                        onClick={handleSalvar}
                        disabled={!!erroCarregamento}
                    >
                        {isMobile ? "💾 Salvar Faixas" : "Salvar Faixas"}
                    </Button>
                </Box>
            </div>

            <Dialog open={confirmacaoAberta} onClose={handleCancelarRemocao}>
                <DialogTitle>Remover faixa</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tem certeza que deseja remover esta faixa de distância? Esta ação não pode
                        ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelarRemocao} color="default">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmarRemocao} style={{ color: "#e53935" }}>
                        Remover
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
